<div class="content-hashtag">
    <p class="title-section"><i class="fa-light {{ icon }}"></i>{{ title }}</p>
    <div class="d-flex line-hashtags">
        <div class="hashtag-item" *ngFor="let item of items">#{{ item }}</div>
    </div>
</div>